import { IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { getGroupType } from 'reactApp/modules/userQuotaCleaner/helpers/getGroupType';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';
import { sendDwh } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';

export const sendDeleteButtonDwh = ({
    name,
    action,
    groupId,
    source,
}: {
    name: 'items_to_safe' | 'items_to_remove';
    action: 'show' | 'click';
    source: 'cleaner';
    groupId?: UserQuotaGroupId;
}) => {
    const dwhData = {
        name,
        paid_user: IS_PAID_USER,
        platform: getPlatformInfo().join('_'),
        group_id: groupId,
        group_type: getGroupType(groupId),
        source,
    };

    const dwh_enabled_fields: (keyof typeof dwhData)[][] = [['name', 'group_id', 'group_type', 'platform']];

    sendDwh({
        eventCategory: 'button',
        action,
        dwh_enabled: true,
        dwh_enabled_fields,
        dwhData,
    });
};
